import { createContext, useCallback, useContext, useEffect, useState } from "react";

const CurrencyContext = createContext(null);

const CURRENCIES = {
  inr: { symbol: "₹", label: "INR", locale: "en-IN" },
  usd: { symbol: "$", label: "USD", locale: "en-US" },
};

function detectDefault() {
  try {
    const stored = localStorage.getItem("cws:currency");
    if (stored && CURRENCIES[stored]) return stored;
  } catch {}
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (tz.includes("Kolkata") || tz.includes("Calcutta") || tz.startsWith("Asia/")) return "inr";
  } catch {}
  return "usd";
}

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState("usd");

  useEffect(() => { setCurrencyState(detectDefault()); }, []);

  const setCurrency = useCallback((c) => {
    if (!CURRENCIES[c]) return;
    setCurrencyState(c);
    try { localStorage.setItem("cws:currency", c); } catch {}
  }, []);

  const format = useCallback((amount, cur = currency) => {
    const meta = CURRENCIES[cur] || CURRENCIES.usd;
    try {
      return new Intl.NumberFormat(meta.locale, {
        style: "currency", currency: meta.label,
        maximumFractionDigits: cur === "inr" ? 0 : 2,
      }).format(Number(amount || 0));
    } catch {
      return `${meta.symbol}${Number(amount || 0).toLocaleString()}`;
    }
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, format, CURRENCIES }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
